<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="统一社会信用代码" prop="uniscid">
                <Input
                  v-model="query.uniscid"
                  clearable
                  placeholder="请输入统一社会信用代码"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="企业名称" prop="entname">
                <Input
                  v-model="query.entname"
                  clearable
                  placeholder="请输入企业名称"
                />
              </form-item>
            </i-col>
          </row>
        </i-form>
      </div>
      <div class="table-data">
        <div class="bottomtable">
          <i-table
            :columns="tableHeader"
            :border="true"
            :loading="isLoading"
            :data="info"
            stripe
            ref="table"
            height="500"
          >
            <template slot-scope="{ row, index }" slot="action"> </template>
          </i-table>
        </div>
      </div>
    </div>

    <!-- <div class="content" v-if="info">
        <div class="search">
          <Form>
            <row :gutter="80" v-for="itme in info">
              <i-col span="8" v-for="(data, key) in itme">
                <FormItem :label="key + ':'">
                  <div class="detail">{{ data }}</div>
                </FormItem>
              </i-col>
            </row>
          </Form>
        </div>
      </div> -->
  </div>
</template>
  
  <script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const { gszjqyjbxxcx } = api;
export default {
  name: "marriageRegister",
  components: {
    pageHead,
  },

  data() {
    return {
      query: {
        entname: "",
        uniscid: "",
      },
      info: undefined,
      isLoading: false,
      tableHeader: [
        { title: "企业名称", key: "entname", align: "center" },
        { title: "企业类型", key: "enttypeCn", align: "center" },
        { title: "成立日期", key: "estdate", align: "center" },
        { title: "法定代表人", key: "name", align: "center" },
        { title: "经营范围", key: "opscope", align: "center" },
        { title: "注册资本", key: "regcap", align: "center" },
        { title: "登记机关", key: "regorgCn", align: "center" },
        { title: "登记状态", key: "regstateCn", align: "center" },
        { title: "注册号", key: "regno", align: "center" },
        //   {title: "原登记日期",key: "原登记日期",align: "center"},
      ],
      title: "企业基本信息查询",
      btnList: [
        {
          name: "重置",
          type: "reset",
        },
        {
          name: "查询",
          type: "search",
        },
      ],
    };
  },
  methods: {
    handleBtn(type) {
      if (type == "reset") {
        this.query.uniscid = "";
        this.query.entname = "";
        this.$refs.search.resetFields();
      } else if (type == "search") {
        this.marriageRegister();
      }
    },
    async marriageRegister() {
      if (!this.query.uniscid) {
        return this.$Message.warning("请输入统一社会信用代码");
      }
      if (!this.query.entname) {
        return this.$Message.warning("请输入企业名称");
      }
      this.isLoading = true;
      try {
        let data = {
          entname: this.query.entname,
          uniscid: this.query.uniscid,
        };
        console.log(data);
        let res = await this.$get(gszjqyjbxxcx, data);
        console.log(JSON.parse(res));
        if (res) {
          this.info = JSON.parse(res).body.data;
        } else {
          this.info = undefined;
        }
      } finally {
        this.isLoading = false;
      }
      console.log(this.query);
    },
  },
  created() {},
  mounted() {},
};
</script>
  
  <style lang="less" scoped>
.content {
  margin: 20px;
}

.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

.label {
  width: 100px;
}

.time {
  width: 100%;
}
</style>
  